import http from '../utils/http';

export interface LogoutResponse {
  success: boolean;
  message: string;
  sessionId: string | null;
  tenantId: string;
  terminatedAt: string;
}

export interface LogoutRequest {
  terminateAllSessions?: boolean;
  reason?: string;
}

/**
 * Logout from magic link session by calling the logout API
 * @param accessToken - The current access token
 * @param options - Optional logout options (terminateAllSessions, reason)
 * @returns Promise with logout response
 */
export const magicLinkLogout = async (
  accessToken: string,
  options?: LogoutRequest,
): Promise<LogoutResponse> => {
  const response = await http<LogoutResponse>(`/shared/auth/logout`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
    body: {
      terminateAllSessions: options?.terminateAllSessions ?? false,
      reason: options?.reason ?? 'user_logout',
    },
  });

  if (response.status === 200 && response.data) {
    return response.data;
  }

  throw new Error('Failed to logout');
};
